var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "1080",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": _vm.banner._id ? '배너 상세보기' : '배너 등록'
    }
  }), _c('v-row', {
    staticClass: "mx-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "이름"
    },
    model: {
      value: _vm.banner.name,
      callback: function ($$v) {
        _vm.$set(_vm.banner, "name", $$v);
      },
      expression: "banner.name"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": "코드"
    },
    model: {
      value: _vm.banner.code,
      callback: function ($$v) {
        _vm.$set(_vm.banner, "code", $$v);
      },
      expression: "banner.code"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-text-field', _vm._b({
    staticClass: "switch-field",
    attrs: {
      "label": "영역 노출",
      "value": _vm.banner.shows ? '노출' : '미노출',
      "readonly": ""
    },
    on: {
      "click": function ($event) {
        _vm.banner.shows = !_vm.banner.shows;
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('v-switch', _vm._b({
          staticClass: "ma-0 ml-1",
          attrs: {
            "dense": ""
          },
          model: {
            value: _vm.banner.shows,
            callback: function ($$v) {
              _vm.$set(_vm.banner, "shows", $$v);
            },
            expression: "banner.shows"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      },
      proxy: true
    }])
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("슬라이드")]), _c('v-divider'), _c('draggable', {
    model: {
      value: _vm.banner.slides,
      callback: function ($$v) {
        _vm.$set(_vm.banner, "slides", $$v);
      },
      expression: "banner.slides"
    }
  }, [_c('transition-group', _vm._l(_vm.banner.slides, function (slide, index) {
    return _c('v-sheet', {
      key: `${index}`
    }, [_c('v-list-item', [_c('v-list-item-action', {
      staticClass: "pa-0 ma-0 mr-4"
    }, [_c('v-preview-input', {
      attrs: {
        "min-width": "96",
        "min-height": "96",
        "max-width": "96",
        "max-height": "96",
        "contain": ""
      },
      model: {
        value: slide.image,
        callback: function ($$v) {
          _vm.$set(slide, "image", $$v);
        },
        expression: "slide.image"
      }
    })], 1), _c('v-divider', {
      attrs: {
        "vertical": ""
      }
    }), _c('v-list-item-content', {
      staticClass: "pa-2"
    }, [_c('v-row', {
      staticClass: "ma-0",
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "5"
      }
    }, [_c('v-text-field', _vm._b({
      attrs: {
        "label": "URL"
      },
      model: {
        value: slide.url,
        callback: function ($$v) {
          _vm.$set(slide, "url", $$v);
        },
        expression: "slide.url"
      }
    }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "5"
      }
    }, [_c('v-select', _vm._b({
      attrs: {
        "label": "링크 유형",
        "items": _vm.targets
      },
      model: {
        value: slide.target,
        callback: function ($$v) {
          _vm.$set(slide, "target", $$v);
        },
        expression: "slide.target"
      }
    }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
      staticClass: "d-none d-lg-block"
    }), _c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "5"
      }
    }, [_c('v-datetime-field', _vm._b({
      attrs: {
        "label": "노출시작일시",
        "clearable": ""
      },
      model: {
        value: slide.showsStartsAt,
        callback: function ($$v) {
          _vm.$set(slide, "showsStartsAt", $$v);
        },
        expression: "slide.showsStartsAt"
      }
    }, 'v-datetime-field', _vm.attrs_input, false))], 1), _c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "5"
      }
    }, [_c('v-datetime-field', _vm._b({
      attrs: {
        "label": "노출종료일시",
        "clearable": ""
      },
      model: {
        value: slide.showsEndsAt,
        callback: function ($$v) {
          _vm.$set(slide, "showsEndsAt", $$v);
        },
        expression: "slide.showsEndsAt"
      }
    }, 'v-datetime-field', _vm.attrs_input, false))], 1), _c('v-col', {
      staticClass: "pa-2",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": ""
      }
    }, [_c('v-switch', _vm._b({
      staticClass: "ma-0 ml-1",
      attrs: {
        "dense": ""
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_vm._v(" " + _vm._s(slide.shows ? "노출" : "미노출") + " ")];
        },
        proxy: true
      }], null, true),
      model: {
        value: slide.shows,
        callback: function ($$v) {
          _vm.$set(slide, "shows", $$v);
        },
        expression: "slide.shows"
      }
    }, 'v-switch', _vm.attrs_switch, false))], 1)], 1)], 1), _c('v-divider', {
      attrs: {
        "vertical": ""
      }
    }), _c('v-list-item-action', [_c('v-icon', {
      on: {
        "click": function ($event) {
          return _vm.banner.slides.splice(index, 1);
        }
      }
    }, [_vm._v("mdi-delete")])], 1)], 1), index !== _vm.banner.slides.length - 1 ? _c('v-divider') : _vm._e()], 1);
  }), 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-file-btn', {
    attrs: {
      "outlined": "",
      "color": "blue",
      "width": "100%",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.upload
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v(" mdi-cloud-upload ")]), _c('span', [_vm._v("배너 이미지 업로드")])], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }